
import Dialog from '~/components/ui/Dialog'
import PricingSlider from '../PricingSlider'
import { InfoIcon } from 'vue-feather-icons'
import RoundTickIcon from '~/components/ui/icon/RoundTickIcon'
import AuthManager from '~/fc/Auth/AuthManager'
import { formatNumberWithCommas } from '~/fc/Helpers/NumericHelpers';
import { priceWithCurrency } from '~/fc/PaymentHelper'

export default {
    name: 'CustomPlanDialog',
    components: {
        Dialog,
        PricingSlider,
        InfoIcon,
        RoundTickIcon
    },
    props: {
        group: {
            default: () => ([]),
            required: true
        },
        activeSubscriptions: {},
        planEligibility: {},
        couponApplied: {},
        discountAmount: {}
    },
    data: () => ({
        loading: false,
        cpuMinutes: null,
        planType: 'custom_annual',
        canContinue: true,
    }),
    computed: {
        baseUrl() { return process.env.BASE_URL },
        authManager () { return new AuthManager(this) },
        priceInputs() { return this.plan?.price?.tiers?.map(tier => tier.start * 100) },
        loggedInAuth () { return this.authManager && this.authManager.auth ? !!this.authManager.auth.token : false },
        loggedIn () { return this.loggedInAuth },
        selectedTier() {
            return this.plan?.price?.tiers?.find(tier => {
                return parseInt(tier.start) * 100 == this.cpuMinutes
            })
        },
        plan() {
            const plan = this.group.find(plan => plan.internalName == this.planType)
            return plan || this.group[0]
        },
        priceAmount() {
            if (!this.selectedTier) return 0
            const minutes = parseFloat(this.cpuMinutes) / 100
            return parseFloat(this.selectedTier.amount * minutes).toFixed(2)
        },
        priceAmountText () { return this.priceAmount ? priceWithCurrency(this.priceAmount, this.plan?.currency) : 0 },
        priceAfterDiscount() {
            return this.couponApplied && this.discountAmount 
                ? parseFloat(this.priceAmount - (this.priceAmount * this.discountAmount / 100)).toFixed(2) 
                : this.priceAmount
        },
        priceAfterDiscountText() { return this.priceAmount ? priceWithCurrency(this.priceAfterDiscount, this.plan?.currency) : 0 },
        priceDuration() {
            const duration = {
                'custom_subscription' : this.$t('month'),
                'custom_annual' : this.$t('year'),
                'custom_credit' : `${this.$t('month')}, ${this.$t('one_time')}`,
            }
            return duration[this.planType]
        },
        eligibility () {
            if (!this.plan) return false
            if (this.plan.type === 'unified-credit') return false;
            if (!this.planEligibility) return false;
            const eligibility = Object.keys(this.planEligibility).find((key) => {
                return this.plan.id === key && this.planEligibility[key].schema === 'volume' && this.planEligibility[key].quantity == ((this.selectedTier?.start || 0) * 100)
            })

            return eligibility ? this.planEligibility[eligibility] : null
        },
        ctaTooltip () {
            return this.eligibility
                ? this.$t(this.eligibility.msg)
                : this.canContinue ? null : $t('purchased_already')
        }
    },
    watch: {
        cpuMinutes(val) {
            this.$emit('cpuMinutes', val)
            this.updateCanContinue();
        },
        planType(val) {
            this.$emit('planType', val)
            this.updateCanContinue();
        },
    },
    mounted() {
    },
    methods: {
        open(props) {
            this.planType = props?.planType || 'custom_annual'
            this.openDialog()
        },
        openDialog() {
            this.$refs.CustomPlanDialog.open()
        },
        /**
         * Fires when Select plan button is clicked.
         */
        select() {
            if (!this.canContinue) return;
            this.$refs.CustomPlanDialog.close()
            this.$emit('select', {
                cpuMinutes: this.cpuMinutes,
                maxFileSizeInGb: this.selectedTier?.maxFileSizeInGb,
                amount: this.priceAmount,
                plan: this.plan
            })
        },
        /**
         * Determines if the update can continue
         */
        updateCanContinue() {
            this.canContinue =
                (!this.eligibility &&
                (!(this.activeSubscriptions?.[this.plan.id]?.schema === 'volume' && this.activeSubscriptions[this.plan.id].quantity === this.cpuMinutes))) ||
                this.planType === 'custom_credit';

        },
        formatNumberWithCommas(str) {
            return formatNumberWithCommas(str)
        }
    },
}
